import { useEffect, useRef, useState } from 'react';
import './../App.css';
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom';
import Law from './Law';

/* ── 대분류 카드 데이터 ── */
const MAIN_CARDS = [
    {
        id: 'design',
        label: '도면설계',
        color: '#4f7fff',
        children: [
            { id: 'request_1', sub: '동바리' },
            { id: 'request_2', sub: '비계' },
            { id: 'request_3', sub: '유로폼 (거푸집)' },
            { id: 'request_4', sub: 'RPP 방음벽 (파이프 타입)' },
            { id: 'request_5', sub: '달비계(공중비계)' },
        ],
    },
    {
        id: 'request_6',
        label: '구조 검토',
        color: '#ff6b4f',
    },
    {
        id: 'request_7',
        label: 'AUTOJH 도면 자동화 설계 프로그램 임대 문의, 데모프로그램 신청',
        color: '#2bc48a',
    },
    {
        id: 'request_8',
        label: '견적 문의 (견적서 신청)',
        color: '#f5a623',
    },
];

/* ── 뱃지용 전체 카드 매핑 ── */
const ALL_CARDS = [
    { id: 'request_1', sub: '동바리', color: '#4f7fff' },
    { id: 'request_2', sub: '비계', color: '#4f7fff' },
    { id: 'request_3', sub: '유로폼 (거푸집)', color: '#4f7fff' },
    { id: 'request_4', sub: 'RPP 방음벽 (파이프 타입)', color: '#4f7fff' },
    { id: 'request_5', sub: '달비계(공중비계)', color: '#4f7fff' },
    { id: 'request_6', sub: '구조 검토', color: '#ff6b4f' },
    { id: 'request_7', sub: '데모프로그램 신청', color: '#2bc48a' },
    { id: 'request_8', sub: '견적 문의', color: '#f5a623' },
];

/* ── 선택내용 라벨 ── */
const SELECTION_LABELS = {
    'request_1': '동바리',
    'request_2': '비계',
    'request_3': '유로폼',
    'request_4': 'RPP 방음벽',
    'request_5': '달비계',
    'request_6': '구조 검토',
    'request_7': '데모신청',
    'request_8': '견적 문의',
};

/* ── 스타일 상수 ── */
const S = {
    page: {
        minHeight: '100vh',
        background: '#f4f6fb',
        padding: '40px 16px 80px',
        fontFamily: 'Noto Sans KR, sans-serif',
    },
    wrap: {
        maxWidth: 860,
        margin: '0 auto',
    },
    stepBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 36,
        gap: 8,
    },
    stepDot: (active, done) => ({
        width: active ? 24 : 8,
        height: 8,
        borderRadius: 4,
        background: done || active ? '#4f7fff' : '#dde3f0',
        transition: 'all .3s',
        flexShrink: 0,
    }),
    cardGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 12,
    },
    card: (selected, color) => ({
        background: selected ? color : '#fff',
        border: `2px solid ${selected ? color : '#e0e5f0'}`,
        borderRadius: 16,
        padding: '22px 16px',
        cursor: 'pointer',
        transition: 'all .2s',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: selected
            ? `0 4px 20px ${color}44`
            : '0 2px 8px rgba(0,0,0,.06)',
    }),
    cardLabel: (selected) => ({
        fontSize: 12,
        color: selected ? 'rgba(255,255,255,.85)' : '#8a94a6',
        marginBottom: 4,
    }),
    cardSub: (selected) => ({
        fontSize: 15,
        fontWeight: 700,
        color: selected ? '#fff' : '#1e2a3a',
        lineHeight: 1.3,
    }),
    sectionBox: {
        background: '#fff',
        borderRadius: 16,
        padding: '28px 24px',
        boxShadow: '0 2px 12px rgba(0,0,0,.07)',
        marginBottom: 20,
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: '#1e2a3a',
        marginBottom: 20,
        paddingBottom: 12,
        borderBottom: '2px solid #f0f2f8',
    },
    fieldRow: {
        marginBottom: 18,
    },
    fieldLabel: {
        fontSize: 13,
        color: '#5a6473',
        fontWeight: 600,
        marginBottom: 8,
        display: 'block',
    },
    input: {
        width: '100%',
        border: '1.5px solid #e0e5f0',
        borderRadius: 10,
        padding: '11px 14px',
        fontSize: 15,
        outline: 'none',
        fontFamily: 'Noto Sans KR, sans-serif',
        transition: 'border .2s',
    },
    textarea: {
        width: '100%',
        border: '1.5px solid #e0e5f0',
        borderRadius: 10,
        padding: '11px 14px',
        fontSize: 15,
        outline: 'none',
        resize: 'vertical',
        fontFamily: 'Noto Sans KR, sans-serif',
        minHeight: 90,
    },
    radioGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
    },
    radioChip: (selected) => ({
        padding: '8px 16px',
        borderRadius: 20,
        border: `1.5px solid ${selected ? '#4f7fff' : '#e0e5f0'}`,
        background: selected ? '#eef2ff' : '#fff',
        color: selected ? '#4f7fff' : '#5a6473',
        fontWeight: selected ? 700 : 400,
        fontSize: 14,
        cursor: 'pointer',
        transition: 'all .15s',
        userSelect: 'none',
    }),
    checkChip: (selected) => ({
        padding: '8px 16px',
        borderRadius: 20,
        border: `1.5px solid ${selected ? '#4f7fff' : '#e0e5f0'}`,
        background: selected ? '#eef2ff' : '#fff',
        color: selected ? '#4f7fff' : '#5a6473',
        fontWeight: selected ? 700 : 400,
        fontSize: 14,
        cursor: 'pointer',
        transition: 'all .15s',
        userSelect: 'none',
        display: 'inline-block',
    }),
    btnRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 32,
        gap: 12,
    },
    btnPrev: {
        flex: 1,
        padding: '14px 0',
        borderRadius: 12,
        border: '1.5px solid #dde3f0',
        background: '#fff',
        color: '#5a6473',
        fontSize: 16,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'Noto Sans KR, sans-serif',
    },
    btnNext: {
        flex: 2,
        padding: '14px 0',
        borderRadius: 12,
        border: 'none',
        background: 'linear-gradient(135deg, #4f7fff 0%, #012394 100%)',
        color: '#fff',
        fontSize: 16,
        fontWeight: 700,
        cursor: 'pointer',
        fontFamily: 'Noto Sans KR, sans-serif',
        boxShadow: '0 4px 16px rgba(79,127,255,.35)',
    },
    badge: (color) => ({
        display: 'inline-block',
        background: `${color}18`,
        color: color,
        border: `1px solid ${color}44`,
        borderRadius: 8,
        padding: '4px 12px',
        fontSize: 13,
        fontWeight: 600,
        margin: '3px 4px',
    }),
    dateInput: {
        display: 'block',
        width: 'auto',
        maxWidth: '100%',
        border: '1.5px solid #e0e5f0',
        borderRadius: 10,
        padding: '11px 14px',
        fontSize: 15,
        outline: 'none',
        fontFamily: 'Noto Sans KR, sans-serif',
    },
};

/* ── 헬퍼: 라디오 칩 ── */
function RadioChips({ name, options, value, onChange }) {
    return (
        <div style={S.radioGroup}>
            {options.map((opt) => (
                <label key={opt} style={S.radioChip(value === opt)}>
                    <input
                        type="radio"
                        name={name}
                        value={opt}
                        checked={value === opt}
                        onChange={() => onChange(opt)}
                        style={{ display: 'none' }}
                        required
                    />
                    {opt}
                </label>
            ))}
        </div>
    );
}

/* ── 헬퍼: 날짜 입력 ── */
function DateInput({ name, value, onChange, required }) {
    const hiddenRef = useRef();
    const openPicker = () => {
        try { hiddenRef.current?.showPicker(); } catch (_) { hiddenRef.current?.focus(); }
    };
    return (
        <div style={{ position: 'relative', cursor: 'pointer' }} onClick={openPicker}>
            <div
                style={{
                    ...S.input,
                    display: 'block',
                    color: value ? '#1e2a3a' : '#aab3c3',
                    background: '#fff',
                }}
            >
                {value || '날짜 선택'}
            </div>
            <input
                ref={hiddenRef}
                type="date"
                name={name}
                required={required}
                value={value || ''}
                onChange={onChange}
                style={{
                    position: 'absolute',
                    top: 0, left: 0, width: '100%', height: '100%',
                    opacity: 0, pointerEvents: 'none',
                }}
            />
        </div>
    );
}

/* ── 헬퍼: 체크 칩 ── */
function CheckChips({ name, options, values, onChange }) {
    return (
        <div style={S.radioGroup}>
            {options.map((opt) => (
                <label key={opt} style={S.checkChip(values.includes(opt))}>
                    <input
                        type="checkbox"
                        name={name}
                        value={opt}
                        checked={values.includes(opt)}
                        onChange={(e) => onChange(opt, e.target.checked)}
                        style={{ display: 'none' }}
                    />
                    {opt}
                </label>
            ))}
        </div>
    );
}

/* ── 스텝 2: 세부 폼 ── */
function DetailForm({ selectedIds, detailData, setDetailData, missingFields = [] }) {
    const set = (key, val) => setDetailData((prev) => ({ ...prev, [key]: val }));
    const isMissing = (key) => missingFields.includes(key);
    const Label = ({ field, children }) => (
        <span style={{ ...S.fieldLabel, color: isMissing(field) ? '#e03e2d' : S.fieldLabel.color }}>
            {children}
        </span>
    );
    const toggle = (key, val, checked) =>
        setDetailData((prev) => {
            const arr = prev[key] || [];
            return {
                ...prev,
                [key]: checked ? [...arr, val] : arr.filter((v) => v !== val),
            };
        });

    const sections = [];

    /* ── 동바리 도면설계 (r1_) ── */
    if (selectedIds.includes('request_1')) {
        sections.push(
            <div key="1" style={S.sectionBox}>
                <div style={S.sectionTitle}>도면설계 — 동바리</div>
                <div style={S.fieldRow}>
                    <Label field="r1_공종">공종</Label>
                    <RadioChips
                        name="r1_공종"
                        options={['시스템 동바리', '강관 동바리(파이프 동바리)', '멀티서포트']}
                        value={detailData.r1_공종 || ''}
                        onChange={(v) => set('r1_공종', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_의뢰종류">의뢰 종류</Label>
                    <RadioChips
                        name="r1_의뢰종류"
                        options={['도면 설계', '견적용 물량도', '샘플 설계']}
                        value={detailData.r1_의뢰종류 || ''}
                        onChange={(v) => set('r1_의뢰종류', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_납기일">납기일</Label>
                    <DateInput
                        name="r1_납기일"
                        required
                        value={detailData.r1_납기일 || ''}
                        onChange={(e) => set('r1_납기일', e.target.value)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_설계기준높이">설계기준높이</Label>
                    <RadioChips
                        name="r1_설계기준높이"
                        options={['슬라브 상단 4.20m 이하', '슬라브 상단 4.20m 초과', '(직접 작성)']}
                        value={detailData.r1_설계기준높이 || ''}
                        onChange={(v) => set('r1_설계기준높이', v)}
                    />
                    {detailData.r1_설계기준높이 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r1_설계기준높이d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r1_설계기준높이d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r1_설계기준높이d || ''}
                            onChange={(e) => set('r1_설계기준높이d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_보하부멍에재방향">보 하부 멍에재 방향</Label>
                    <RadioChips
                        name="r1_보하부멍에재방향"
                        options={['장방향', '단방향']}
                        value={detailData.r1_보하부멍에재방향 || ''}
                        onChange={(v) => set('r1_보하부멍에재방향', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_눈썹보설치기준">눈썹보 설치 기준</Label>
                    <RadioChips
                        name="r1_눈썹보설치기준"
                        options={['300mm 이상 설계', '설계 안함', '(직접 작성)']}
                        value={detailData.r1_눈썹보설치기준 || ''}
                        onChange={(v) => set('r1_눈썹보설치기준', v)}
                    />
                    {detailData.r1_눈썹보설치기준 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r1_눈썹보설치기준d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r1_눈썹보설치기준d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r1_눈썹보설치기준d || ''}
                            onChange={(e) => set('r1_눈썹보설치기준d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_단열재">단열재</Label>
                    <RadioChips
                        name="r1_단열재"
                        options={['선시공', '후시공']}
                        value={detailData.r1_단열재 || ''}
                        onChange={(v) => set('r1_단열재', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_분할타설">분할타설</Label>
                    <RadioChips
                        name="r1_분할타설"
                        options={['일괄타설 (분할타설 X)', '분할타설 1차 1000mm', '(직접 작성)']}
                        value={detailData.r1_분할타설 || ''}
                        onChange={(v) => set('r1_분할타설', v)}
                    />
                    {detailData.r1_분할타설 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r1_분할타설d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r1_분할타설d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r1_분할타설d || ''}
                            onChange={(e) => set('r1_분할타설d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_기전실패드">기전실 패드</Label>
                    <RadioChips
                        name="r1_기전실패드"
                        options={['선시공', '후시공']}
                        value={detailData.r1_기전실패드 || ''}
                        onChange={(v) => set('r1_기전실패드', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_방수턱">방수턱</Label>
                    <RadioChips
                        name="r1_방수턱"
                        options={['선시공', '후시공']}
                        value={detailData.r1_방수턱 || ''}
                        onChange={(v) => set('r1_방수턱', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_데크구간발판용날개">데크 구간 발판용 날개</Label>
                    <RadioChips
                        name="r1_데크구간발판용날개"
                        options={['설계', '설계 안함']}
                        value={detailData.r1_데크구간발판용날개 || ''}
                        onChange={(v) => set('r1_데크구간발판용날개', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_RC구간동바리발판도">RC 구간 동바리 발판도</Label>
                    <RadioChips
                        name="r1_RC구간동바리발판도"
                        options={['설계', '설계 안함']}
                        value={detailData.r1_RC구간동바리발판도 || ''}
                        onChange={(v) => set('r1_RC구간동바리발판도', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_물량산출기준">물량산출기준</Label>
                    <RadioChips
                        name="r1_물량산출기준"
                        options={['기본 적용', '(직접 작성)']}
                        value={detailData.r1_물량산출기준 || ''}
                        onChange={(v) => set('r1_물량산출기준', v)}
                    />
                    {detailData.r1_물량산출기준 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r1_물량산출기준d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r1_물량산출기준d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r1_물량산출기준d || ''}
                            onChange={(e) => set('r1_물량산출기준d', e.target.value)}
                        />
                    )}
                    {detailData.r1_물량산출기준 === '기본 적용' && (
                        <div style={{ marginTop: 10, fontSize: 13, color: '#5a6473', lineHeight: 1.8, background: '#f8f9fc', borderRadius: 8, padding: '12px 14px' }}>
                            <strong>[RC]</strong><br/>
                            면적 : 평면상 벽체 내측면 면적<br/>
                            높이 : 슬라브 상단 높이<br/>
                            체적(㎥)=면적*높이*0.9<br/>
                            <strong>[DECK]</strong><br/>
                            면적 : 보 실면적<br/>
                            높이 : 보 하단 높이<br/>
                            체적(㎥)=면적*높이<br/>
                            <strong>[DECK 보강]</strong><br/>
                            면적 : 보 실면적<br/>
                            높이 : 슬라브 하단 높이<br/>
                            체적(㎥)=면적*높이
                        </div>
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_자재타입">자재 타입</Label>
                    <RadioChips
                        name="r1_자재타입"
                        options={['OK타입 (H18=1829mm) 설계', '(직접 작성)']}
                        value={detailData.r1_자재타입 || ''}
                        onChange={(v) => set('r1_자재타입', v)}
                    />
                    {detailData.r1_자재타입 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r1_자재타입d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r1_자재타입d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r1_자재타입d || ''}
                            onChange={(e) => set('r1_자재타입d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_구조검토">구조 검토</Label>
                    <RadioChips
                        name="r1_구조검토"
                        options={['비날인 구조계산서 (구조기술사 도장 X)', '날인 구조계산서 (구조기술사 도장 O)']}
                        value={detailData.r1_구조검토 || ''}
                        onChange={(v) => set('r1_구조검토', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r1_특이사항">특이사항</Label>
                    <textarea
                        name="r1_특이사항"
                        style={S.textarea}
                        placeholder="특이사항을 입력해주세요"
                        value={detailData.r1_특이사항 || ''}
                        onChange={(e) => set('r1_특이사항', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    /* ── 비계 도면설계 (r2_) ── */
    if (selectedIds.includes('request_2')) {
        sections.push(
            <div key="2" style={S.sectionBox}>
                <div style={S.sectionTitle}>도면설계 — 비계</div>
                <div style={S.fieldRow}>
                    <Label field="r2_공종">공종</Label>
                    <RadioChips
                        name="r2_공종"
                        options={['시스템 비계', '강관 비계(파이프 비계)', '클린사업']}
                        value={detailData.r2_공종 || ''}
                        onChange={(v) => set('r2_공종', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_의뢰종류">의뢰 종류</Label>
                    <RadioChips
                        name="r2_의뢰종류"
                        options={['도면 설계', '견적용 물량도', '샘플 설계']}
                        value={detailData.r2_의뢰종류 || ''}
                        onChange={(v) => set('r2_의뢰종류', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_납기일">납기일</Label>
                    <DateInput
                        name="r2_납기일"
                        required
                        value={detailData.r2_납기일 || ''}
                        onChange={(e) => set('r2_납기일', e.target.value)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_발판유형">발판 유형</Label>
                    <RadioChips
                        name="r2_발판유형"
                        options={['1장 타입 (폭 500 1장)', '2장 타입 (폭 400 2장)', '수평 비계', '(직접 작성)']}
                        value={detailData.r2_발판유형 || ''}
                        onChange={(v) => set('r2_발판유형', v)}
                    />
                    {detailData.r2_발판유형 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r2_발판유형d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r2_발판유형d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r2_발판유형d || ''}
                            onChange={(e) => set('r2_발판유형d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_비계사용용도">비계 사용용도</Label>
                    <RadioChips
                        name="r2_비계사용용도"
                        options={['골조 작업용', '골조+마감 작업용', '돌 마감 작업용', '경량 마감 작업용', '(직접 작성)']}
                        value={detailData.r2_비계사용용도 || ''}
                        onChange={(v) => set('r2_비계사용용도', v)}
                    />
                    {detailData.r2_비계사용용도 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r2_비계사용용도d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r2_비계사용용도d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r2_비계사용용도d || ''}
                            onChange={(e) => set('r2_비계사용용도d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_수직이동통로유형">수직 이동통로 유형</Label>
                    <RadioChips
                        name="r2_수직이동통로유형"
                        options={['워킹타워 1개소+개구부발판', '개구부발판 30m 이내 1개소', '(직접 작성)']}
                        value={detailData.r2_수직이동통로유형 || ''}
                        onChange={(v) => set('r2_수직이동통로유형', v)}
                    />
                    {detailData.r2_수직이동통로유형 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r2_수직이동통로유형d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r2_수직이동통로유형d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r2_수직이동통로유형d || ''}
                            onChange={(e) => set('r2_수직이동통로유형d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_방호선반">방호선반</Label>
                    <RadioChips
                        name="r2_방호선반"
                        options={['설계', '설계안함']}
                        value={detailData.r2_방호선반 || ''}
                        onChange={(v) => set('r2_방호선반', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_비계시작위치">비계 시작 위치</Label>
                    <RadioChips
                        name="r2_비계시작위치"
                        options={['GL (지상층 지하층 별도 설계)', 'GL (지상층만 설계)', '기초 하단', '기초 상단', '버림 상단', '(직접 작성)']}
                        value={detailData.r2_비계시작위치 || ''}
                        onChange={(v) => set('r2_비계시작위치', v)}
                    />
                    {detailData.r2_비계시작위치 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r2_비계시작위치d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r2_비계시작위치d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r2_비계시작위치d || ''}
                            onChange={(e) => set('r2_비계시작위치d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_비계설계구간">비계 설계 구간</Label>
                    <RadioChips
                        name="r2_비계설계구간"
                        options={['외부 전체', '내부 오픈구', '외부 전체+내부 오픈구', '외부+내부 전체', '기준층 밑 설계(갱폼 적용)', '(직접 작성)']}
                        value={detailData.r2_비계설계구간 || ''}
                        onChange={(v) => set('r2_비계설계구간', v)}
                    />
                    {detailData.r2_비계설계구간 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r2_비계설계구간d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r2_비계설계구간d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r2_비계설계구간d || ''}
                            onChange={(e) => set('r2_비계설계구간d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_최하단발판설치여부">최하단 발판 설치 여부</Label>
                    <RadioChips
                        name="r2_최하단발판설치여부"
                        options={['설계', '설계 안함']}
                        value={detailData.r2_최하단발판설치여부 || ''}
                        onChange={(v) => set('r2_최하단발판설치여부', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_자재타입">자재타입</Label>
                    <RadioChips
                        name="r2_자재타입"
                        options={['OK타입 (H18=1817mm) 설계', '도끼 타입 (H18=1829mm) 설계', '(직접 작성)']}
                        value={detailData.r2_자재타입 || ''}
                        onChange={(v) => set('r2_자재타입', v)}
                    />
                    {detailData.r2_자재타입 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r2_자재타입d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r2_자재타입d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r2_자재타입d || ''}
                            onChange={(e) => set('r2_자재타입d', e.target.value)}
                        />
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_물량산출기준">물량산출기준</Label>
                    <RadioChips
                        name="r2_물량산출기준"
                        options={['기본 적용', '(직접 작성)']}
                        value={detailData.r2_물량산출기준 || ''}
                        onChange={(v) => set('r2_물량산출기준', v)}
                    />
                    {detailData.r2_물량산출기준 === '(직접 작성)' && (
                        <input
                            type="text"
                            name="r2_물량산출기준d"
                            style={{ ...S.input, marginTop: 10, ...(isMissing('r2_물량산출기준d') && { borderColor: '#e03e2d' }) }}
                            placeholder="직접 입력"
                            required
                            value={detailData.r2_물량산출기준d || ''}
                            onChange={(e) => set('r2_물량산출기준d', e.target.value)}
                        />
                    )}
                    {detailData.r2_물량산출기준 === '기본 적용' && (
                        <div style={{ marginTop: 10, fontSize: 13, color: '#5a6473', lineHeight: 1.8, background: '#f8f9fc', borderRadius: 8, padding: '12px 14px' }}>
                            <strong>[외부 비계]</strong><br/>
                            길이 : 골조에서 1000mm 이격<br/>
                            높이 : 최상단 발판 높이 +1200mm<br/>
                            면적(㎡)=길이*높이<br/>
                            <strong>[내부 비계]</strong><br/>
                            길이 : 골조에서 400mm 이격<br/>
                            높이 : 최상단 발판 높이 +1200mm<br/>
                            면적(㎡)=길이*높이<br/>
                            <strong>[수평 비계]</strong><br/>
                            면적 : 평면상 벽체 내측면 면적<br/>
                            높이 : 최상단 발판 높이 +1200mm<br/>
                            체적(㎥)=면적*높이
                        </div>
                    )}
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_구조검토">구조 검토</Label>
                    <RadioChips
                        name="r2_구조검토"
                        options={['비날인 구조계산서 (구조기술사 도장 X)', '날인 구조계산서 (구조기술사 도장 O)']}
                        value={detailData.r2_구조검토 || ''}
                        onChange={(v) => set('r2_구조검토', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r2_특이사항">특이사항</Label>
                    <textarea
                        name="r2_특이사항"
                        style={S.textarea}
                        placeholder="특이사항을 입력해주세요"
                        value={detailData.r2_특이사항 || ''}
                        onChange={(e) => set('r2_특이사항', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    /* ── 유로폼 (r3_) ── */
    if (selectedIds.includes('request_3')) {
        sections.push(
            <div key="3" style={S.sectionBox}>
                <div style={S.sectionTitle}>도면설계 — 유로폼 (거푸집)</div>
                <div style={S.fieldRow}>
                    <Label field="r3_납기일">납기일</Label>
                    <DateInput
                        name="r3_납기일"
                        required
                        value={detailData.r3_납기일 || ''}
                        onChange={(e) => set('r3_납기일', e.target.value)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r3_특이사항">특이사항</Label>
                    <textarea
                        name="r3_특이사항"
                        style={S.textarea}
                        placeholder="특이사항을 입력해주세요"
                        value={detailData.r3_특이사항 || ''}
                        onChange={(e) => set('r3_특이사항', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    /* ── RPP 방음벽 (r4_) ── */
    if (selectedIds.includes('request_4')) {
        sections.push(
            <div key="4" style={S.sectionBox}>
                <div style={S.sectionTitle}>도면설계 — RPP 방음벽 (파이프 타입)</div>
                <div style={S.fieldRow}>
                    <Label field="r4_납기일">납기일</Label>
                    <DateInput
                        name="r4_납기일"
                        required
                        value={detailData.r4_납기일 || ''}
                        onChange={(e) => set('r4_납기일', e.target.value)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r4_특이사항">특이사항</Label>
                    <textarea
                        name="r4_특이사항"
                        style={S.textarea}
                        placeholder="특이사항을 입력해주세요"
                        value={detailData.r4_특이사항 || ''}
                        onChange={(e) => set('r4_특이사항', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    /* ── 달비계 (r5_) ── */
    if (selectedIds.includes('request_5')) {
        sections.push(
            <div key="5" style={S.sectionBox}>
                <div style={S.sectionTitle}>도면설계 — 달비계(공중비계)</div>
                <div style={S.fieldRow}>
                    <Label field="r5_납기일">납기일</Label>
                    <DateInput
                        name="r5_납기일"
                        required
                        value={detailData.r5_납기일 || ''}
                        onChange={(e) => set('r5_납기일', e.target.value)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r5_특이사항">특이사항</Label>
                    <textarea
                        name="r5_특이사항"
                        style={S.textarea}
                        placeholder="특이사항을 입력해주세요"
                        value={detailData.r5_특이사항 || ''}
                        onChange={(e) => set('r5_특이사항', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    /* ── 구조 검토 (r6_) ── */
    if (selectedIds.includes('request_6')) {
        sections.push(
            <div key="6" style={S.sectionBox}>
                <div style={S.sectionTitle}>구조 검토</div>
                <div style={S.fieldRow}>
                    <Label field="r6_공종">공종 (복수 선택 가능)</Label>
                    <CheckChips
                        name="r6_공종"
                        options={['시스템 동바리', '시스템 비계', '강관 동바리', '강관 비계', '유로폼 (거푸집)', 'RPP방음벽 (파이프타입)', '달비계(공중비계)', '멀티서포트']}
                        values={detailData.r6_공종 || []}
                        onChange={(v, checked) => toggle('r6_공종', v, checked)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r6_의뢰종류">의뢰 종류</Label>
                    <RadioChips
                        name="r6_의뢰종류"
                        options={['비날인 구조계산서 (구조기술사 도장 X)', '날인 구조계산서 (구조기술사 도장 O)']}
                        value={detailData.r6_의뢰종류 || ''}
                        onChange={(v) => set('r6_의뢰종류', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r6_납기일">납기일</Label>
                    <DateInput
                        name="r6_납기일"
                        required
                        value={detailData.r6_납기일 || ''}
                        onChange={(e) => set('r6_납기일', e.target.value)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r6_검토형태">검토형태</Label>
                    <RadioChips
                        name="r6_검토형태"
                        options={['2D 검토', '3D 검토', '구조기술사 의견서', 'PDF 날인']}
                        value={detailData.r6_검토형태 || ''}
                        onChange={(v) => set('r6_검토형태', v)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r6_특이사항">특이사항</Label>
                    <textarea
                        name="r6_특이사항"
                        style={S.textarea}
                        placeholder="특이사항을 입력해주세요"
                        value={detailData.r6_특이사항 || ''}
                        onChange={(e) => set('r6_특이사항', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    /* ── 자동화 프로그램 (r7_) ── */
    if (selectedIds.includes('request_7')) {
        sections.push(
            <div key="7" style={S.sectionBox}>
                <div style={S.sectionTitle}>AUTOJH 도면 자동화 설계 프로그램 임대 문의, 데모프로그램 신청</div>
                <div style={S.fieldRow}>
                    <Label field="r7_CAD종류">CAD 종류</Label>
                    <input
                        type="text"
                        name="r7_CAD종류"
                        style={S.input}
                        placeholder="예: AutoCAD, BricsCAD 등"
                        required
                        value={detailData.r7_CAD종류 || ''}
                        onChange={(e) => set('r7_CAD종류', e.target.value)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r7_CAD버전">CAD 버전</Label>
                    <input
                        type="text"
                        name="r7_CAD버전"
                        style={S.input}
                        placeholder="예: 2022, 2024 등"
                        required
                        value={detailData.r7_CAD버전 || ''}
                        onChange={(e) => set('r7_CAD버전', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    /* ── 견적 문의 (r8_) ── */
    if (selectedIds.includes('request_8')) {
        sections.push(
            <div key="8" style={S.sectionBox}>
                <div style={S.sectionTitle}>견적 문의 (견적서 신청)</div>
                <div style={S.fieldRow}>
                    <Label field="r8_종류">종류 (복수 선택 가능)</Label>
                    <CheckChips
                        name="r8_종류"
                        options={['도면', '구조검토', '견적용 물량도']}
                        values={detailData.r8_종류 || []}
                        onChange={(v, checked) => toggle('r8_종류', v, checked)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r8_공종">공종 (복수 선택 가능)</Label>
                    <CheckChips
                        name="r8_공종"
                        options={['시스템 동바리', '시스템 비계', '강관 동바리', '강관 비계', '유로폼', 'RPP방음벽(파이프타입)', '달비계(공중비계)', '멀티서포트']}
                        values={detailData.r8_공종 || []}
                        onChange={(v, checked) => toggle('r8_공종', v, checked)}
                    />
                </div>
                <div style={S.fieldRow}>
                    <Label field="r8_특이사항">특이사항</Label>
                    <textarea
                        name="r8_특이사항"
                        style={S.textarea}
                        placeholder="특이사항을 입력해주세요"
                        value={detailData.r8_특이사항 || ''}
                        onChange={(e) => set('r8_특이사항', e.target.value)}
                    />
                </div>
            </div>
        );
    }

    return <>{sections}</>;
}

/* ── 스텝 인디케이터 ── */
function StepIndicator({ step }) {
    const total = 3;
    return (
        <div style={S.stepBar}>
            {Array.from({ length: total }, (_, i) => {
                const idx = i + 1;
                const active = step === idx;
                const done = step > idx;
                return <div key={i} style={S.stepDot(active, done)} />;
            })}
        </div>
    );
}

/* ── 메인 컴포넌트 ── */
export default function Intro() {
    const navigate = useNavigate();
    const form = useRef();

    const [step, setStep] = useState(1);
    const [selectedIds, setSelectedIds] = useState([]);
    const [expandDesign, setExpandDesign] = useState(false);
    const designRef = useRef();
    const [detailData, setDetailData] = useState({});

    useEffect(() => {
        if (!expandDesign) return;
        const handleClick = (e) => {
            if (designRef.current && !designRef.current.contains(e.target)) {
                setExpandDesign(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [expandDesign]);
    const formatPhone = (value) => {
        const num = value.replace(/[^0-9]/g, '');
        if (num.startsWith('02')) {
            if (num.length <= 2) return num;
            if (num.length <= 6) return `${num.slice(0, 2)}-${num.slice(2)}`;
            return `${num.slice(0, 2)}-${num.slice(2, 6)}-${num.slice(6, 10)}`;
        }
        if (num.length <= 3) return num;
        if (num.length <= 7) return `${num.slice(0, 3)}-${num.slice(3)}`;
        return `${num.slice(0, 3)}-${num.slice(3, 7)}-${num.slice(7, 11)}`;
    };

    const [missingFields, setMissingFields] = useState([]);
    const [companyData, setCompanyData] = useState({
        업체명: '', 담당자: '', 연락처: '', 현장명: '', user_email: '', 개인정보: false,
    });

    const toggleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
        );
    };

    const REQUIRED_FIELDS = {
        request_1: ['r1_공종', 'r1_의뢰종류', 'r1_납기일', 'r1_설계기준높이', 'r1_보하부멍에재방향', 'r1_눈썹보설치기준', 'r1_단열재', 'r1_분할타설', 'r1_기전실패드', 'r1_방수턱', 'r1_데크구간발판용날개', 'r1_RC구간동바리발판도', 'r1_물량산출기준', 'r1_자재타입', 'r1_구조검토'],
        request_2: ['r2_공종', 'r2_의뢰종류', 'r2_납기일', 'r2_발판유형', 'r2_비계사용용도', 'r2_수직이동통로유형', 'r2_방호선반', 'r2_비계시작위치', 'r2_비계설계구간', 'r2_최하단발판설치여부', 'r2_자재타입', 'r2_물량산출기준', 'r2_구조검토'],
        request_3: ['r3_납기일'],
        request_4: ['r4_납기일'],
        request_5: ['r5_납기일'],
        request_6: ['r6_의뢰종류', 'r6_납기일', 'r6_검토형태'],
        request_7: ['r7_CAD종류', 'r7_CAD버전'],
        request_8: [],
    };

    const goNext = () => {
        if (step === 1 && selectedIds.length === 0) {
            alert('의뢰 종류를 하나 이상 선택해주세요.');
            return;
        }
        if (step === 2) {
            const missing = [];
            selectedIds.forEach(id => {
                const fields = REQUIRED_FIELDS[id] || [];
                fields.forEach(f => {
                    const val = detailData[f];
                    if (!val || (Array.isArray(val) && val.length === 0)) {
                        missing.push(f);
                    }
                    if (val === '(직접 작성)' && !detailData[f + 'd']?.trim()) {
                        missing.push(f + 'd');
                    }
                });
            });
            if (missing.length > 0) {
                setMissingFields(missing);
                alert('미입력 항목이 있습니다. 빨간색으로 표시된 항목을 확인해주세요.');
                return;
            }
            setMissingFields([]);
        }
        setStep((s) => s + 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const goPrev = () => {
        setStep((s) => s - 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const [missingCompany, setMissingCompany] = useState([]);

    const sendEmail = (e) => {
        e.preventDefault();
        const companyMissing = [];
        if (!companyData.업체명.trim()) companyMissing.push('업체명');
        if (!companyData.담당자.trim()) companyMissing.push('담당자');
        if (!companyData.연락처.trim()) companyMissing.push('연락처');
        if (!companyData.현장명.trim()) companyMissing.push('현장명');
        if (!companyData.user_email.trim()) companyMissing.push('user_email');
        if (!companyData.개인정보) companyMissing.push('개인정보');
        if (companyMissing.length > 0) {
            setMissingCompany(companyMissing);
            alert('미입력 항목이 있습니다. 빨간색으로 표시된 항목을 확인해주세요.');
            return;
        }
        setMissingCompany([]);
        emailjs
            .sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_SECRET_KEY)
            .then(
                () => {
                    alert('의뢰서 전송이 완료되었습니다. 다음 단계를 진행해주세요.');
                    navigate('/upload');
                    window.location.reload();
                },
                (err) => {
                    console.log(err);
                    alert('이메일 전송이 실패되었습니다.');
                }
            );
    };

    return (
        <div style={S.page}>
            <div style={S.wrap}>
                {/* 로고 */}
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <img src="/images/logo.png" alt="JH시스템" style={{ width: 56, marginBottom: 8 }} />
                    <div style={{ fontSize: 13, color: '#8a94a6' }}>가설 구조물 도면 설계 전문회사 JH시스템</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: '#1e2a3a', marginTop: 4, letterSpacing: -0.5 }}>의뢰 접수 시스템</div>

                </div>

                <StepIndicator step={step} />

                <form ref={form} onSubmit={sendEmail}>
                    {/* ── STEP 1 ── */}
                    {step === 1 && (
                        <div>
                            <div style={{ ...S.sectionBox, marginBottom: 24 }}>
                                <div style={S.sectionTitle}>어떤 서비스가 필요하신가요?</div>
                                <p style={{ fontSize: 13, color: '#8a94a6', marginBottom: 20, marginTop: -8 }}>
                                    복수 선택 가능합니다.
                                </p>
                                <div className="card-grid" style={S.cardGrid}>
                                    {MAIN_CARDS.map((card) => {
                                        if (card.children) {
                                            const hasChild = card.children.some(c => selectedIds.includes(c.id));
                                            return (
                                                <div key={card.id} ref={designRef} style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                                                    <div
                                                        style={{ ...S.card(hasChild, card.color), marginBottom: 0, flex: 1 }}
                                                        onClick={() => setExpandDesign(prev => !prev)}
                                                    >
                                                        <div style={S.cardSub(hasChild)}>{card.label}</div>
                                                        {hasChild && (
                                                            <div style={{ fontSize: 11, color: hasChild ? 'rgba(255,255,255,.7)' : '#aab3c3', marginTop: 6, lineHeight: 1.4 }}>
                                                                {card.children.filter(c => selectedIds.includes(c.id)).map(c => c.sub).join(', ')}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {expandDesign && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            right: 0,
                                                            zIndex: 10,
                                                            background: '#fff',
                                                            borderRadius: '0 0 12px 12px',
                                                            boxShadow: '0 8px 24px rgba(0,0,0,.12)',
                                                            border: '1.5px solid #e0e5f0',
                                                            borderTop: 'none',
                                                            overflow: 'hidden',
                                                        }}>
                                                            {card.children.map((child) => {
                                                                const childSel = selectedIds.includes(child.id);
                                                                return (
                                                                    <div
                                                                        key={child.id}
                                                                        style={{
                                                                            padding: '12px 16px',
                                                                            fontSize: 14,
                                                                            cursor: 'pointer',
                                                                            background: childSel ? '#eef2ff' : '#fff',
                                                                            color: childSel ? '#4f7fff' : '#1e2a3a',
                                                                            fontWeight: childSel ? 700 : 400,
                                                                            borderBottom: '1px solid #f0f2f8',
                                                                            transition: 'all .15s',
                                                                        }}
                                                                        onClick={(e) => { e.stopPropagation(); toggleSelect(child.id); }}
                                                                    >
                                                                        {childSel ? '✓ ' : ''}{child.sub}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        }
                                        const sel = selectedIds.includes(card.id);
                                        return (
                                            <div
                                                key={card.id}
                                                style={S.card(sel, card.color)}
                                                onClick={() => toggleSelect(card.id)}
                                            >
                                                <div style={S.cardSub(sel)}>{card.label}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div style={{ ...S.btnRow, justifyContent: 'flex-end' }}>
                                <button type="button" style={{ ...S.btnNext, flex: '0 0 200px' }} onClick={goNext}>
                                    다음 단계 →
                                </button>
                            </div>
                        </div>
                    )}

                    {/* ── STEP 2 ── */}
                    {step === 2 && (
                        <div>
                            <div style={{ ...S.sectionBox, marginBottom: 20 }}>
                                <div style={{ fontSize: 13, color: '#8a94a6', marginBottom: 8 }}>선택하신 의뢰 종류</div>
                                {ALL_CARDS.filter((c) => selectedIds.includes(c.id)).map((c) => (
                                    <span key={c.id} style={S.badge(c.color)}>
                                        {c.sub}
                                    </span>
                                ))}
                            </div>

                            <DetailForm
                                selectedIds={selectedIds}
                                detailData={detailData}
                                setDetailData={setDetailData}
                                missingFields={missingFields}
                            />

                            <div style={S.btnRow}>
                                <button type="button" style={S.btnPrev} onClick={goPrev}>← 이전</button>
                                <button type="button" style={S.btnNext} onClick={goNext}>다음 단계 →</button>
                            </div>
                        </div>
                    )}

                    {/* ── STEP 3 ── */}
                    {step === 3 && (
                        <div>
                            {/* 의뢰 내용 요약 */}
                            <div style={{ ...S.sectionBox, marginBottom: 20 }}>
                                <div style={S.sectionTitle}>의뢰 내용 확인</div>
                                {ALL_CARDS.filter((c) => selectedIds.includes(c.id)).map((c) => (
                                    <span key={c.id} style={S.badge(c.color)}>
                                        {c.sub}
                                    </span>
                                ))}
                            </div>

                            {/* 회사 정보 입력 */}
                            <div style={S.sectionBox}>
                                <div style={S.sectionTitle}>회사 / 담당자 정보</div>

                                {/* hidden: 선택된 의뢰종류 전달 (Mustache 조건용) */}
                                {selectedIds.includes('request_1') && <input type="hidden" name="의뢰종류_1" value="동바리 도면설계" />}
                                {selectedIds.includes('request_2') && <input type="hidden" name="의뢰종류_2" value="비계 도면설계" />}
                                {selectedIds.includes('request_3') && <input type="hidden" name="의뢰종류_3" value="유로폼 도면설계" />}
                                {selectedIds.includes('request_4') && <input type="hidden" name="의뢰종류_4" value="RPP방음벽 도면설계" />}
                                {selectedIds.includes('request_5') && <input type="hidden" name="의뢰종류_5" value="달비계 도면설계" />}
                                {selectedIds.includes('request_6') && <input type="hidden" name="의뢰종류_6" value="구조검토" />}
                                {selectedIds.includes('request_7') && <input type="hidden" name="의뢰종류_7" value="자동화설계프로그램" />}
                                {selectedIds.includes('request_8') && <input type="hidden" name="의뢰종류_8" value="견적문의" />}

                                {/* hidden: 선택내용 요약 */}
                                <input type="hidden" name="선택내용" value={selectedIds.map(id => SELECTION_LABELS[id] || id).join(', ')} />

                                {/* detailData를 hidden input으로 전달 */}
                                {Object.entries(detailData).map(([k, v]) => {
                                    const val = Array.isArray(v) ? v.join(', ') : v;
                                    return val ? <input key={k} type="hidden" name={k} value={val} /> : null;
                                })}

                                <div style={S.fieldRow}>
                                    <span style={{ ...S.fieldLabel, color: missingCompany.includes('업체명') ? '#e03e2d' : S.fieldLabel.color }}>업체명 (의뢰하는 회사) *</span>
                                    <input
                                        type="text"
                                        name="업체명"
                                        style={S.input}
                                        placeholder="의뢰하는 회사명을 입력해주세요"
                                        required
                                        value={companyData.업체명}
                                        onChange={(e) => setCompanyData((p) => ({ ...p, 업체명: e.target.value }))}
                                    />
                                </div>
                                <div style={S.fieldRow}>
                                    <span style={{ ...S.fieldLabel, color: missingCompany.includes('담당자') ? '#e03e2d' : S.fieldLabel.color }}>담당자 (의뢰자) 성함 *</span>
                                    <input
                                        type="text"
                                        name="담당자"
                                        style={S.input}
                                        placeholder="의뢰자 성함을 입력해주세요"
                                        required
                                        value={companyData.담당자}
                                        onChange={(e) => setCompanyData((p) => ({ ...p, 담당자: e.target.value }))}
                                    />
                                </div>
                                <div style={S.fieldRow}>
                                    <span style={{ ...S.fieldLabel, color: missingCompany.includes('연락처') ? '#e03e2d' : S.fieldLabel.color }}>연락처 *</span>
                                    <input
                                        type="text"
                                        name="연락처"
                                        style={S.input}
                                        placeholder="010-0000-0000"
                                        required
                                        value={companyData.연락처}
                                        onChange={(e) => setCompanyData((p) => ({ ...p, 연락처: formatPhone(e.target.value) }))}
                                    />
                                </div>
                                <div style={S.fieldRow}>
                                    <span style={{ ...S.fieldLabel, color: missingCompany.includes('현장명') ? '#e03e2d' : S.fieldLabel.color }}>현장명 *</span>
                                    <input
                                        type="text"
                                        name="현장명"
                                        style={S.input}
                                        placeholder="현장명을 입력해주세요"
                                        required
                                        value={companyData.현장명}
                                        onChange={(e) => setCompanyData((p) => ({ ...p, 현장명: e.target.value }))}
                                    />
                                </div>
                                <div style={S.fieldRow}>
                                    <span style={{ ...S.fieldLabel, color: missingCompany.includes('user_email') ? '#e03e2d' : S.fieldLabel.color }}>ID (보내는 사람 메일주소) *</span>
                                    <input
                                        type="email"
                                        name="user_email"
                                        style={S.input}
                                        placeholder="example@email.com"
                                        required
                                        value={companyData.user_email}
                                        onChange={(e) => setCompanyData((p) => ({ ...p, user_email: e.target.value }))}
                                    />
                                </div>

                                {/* 개인정보동의 */}
                                <div style={{ ...S.fieldRow, background: '#f8f9fc', borderRadius: 10, padding: '14px 16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <input
                                            type="checkbox"
                                            name="?"
                                            id="privacy"
                                            style={{ width: 18, height: 18, cursor: 'pointer', accentColor: '#4f7fff' }}
                                            required
                                            checked={companyData.개인정보}
                                            onChange={(e) => setCompanyData((p) => ({ ...p, 개인정보: e.target.checked }))}
                                        />
                                        <label htmlFor="privacy" style={{ fontSize: 14, color: '#5a6473', cursor: 'pointer' }}>
                                            개인정보처리방침에 동의합니다. <span style={{ color: '#4f7fff', fontWeight: 600 }}>(필수)</span>
                                        </label>
                                        <span style={{ marginLeft: 'auto' }}>
                                            <Law />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* 회사 연락처 */}
                            <div style={{ ...S.sectionBox, marginTop: 16, background: '#f8f9fc' }}>
                                <div style={{ fontSize: 13, color: '#8a94a6', lineHeight: 2 }}>
                                    <div>회사 대표 연락처: <strong style={{ color: '#1e2a3a' }}>010-5762-1829</strong></div>
                                    <div>회사 대표 이메일 주소: <strong style={{ color: '#1e2a3a' }}>jhsystem@jhsystem.by-works.com</strong></div>
                                    <div>회사 홈페이지 주소: <a href="https://jhsystem.clickn.co.kr" target="_blank" rel="noreferrer" style={{ color: '#4f7fff' }}>https://jhsystem.clickn.co.kr</a></div>
                                </div>
                            </div>

                            <div style={S.btnRow}>
                                <button type="button" style={S.btnPrev} onClick={goPrev}>← 이전</button>
                                <button type="submit" style={S.btnNext}>의뢰서 제출하기</button>
                            </div>
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}
